import { useEffect, useState } from "react";
import { getDeviationsRequest } from "../../../../../services/DriverCardService";
import { DeclineFormInputData, ICheckbox, IDeviation, IMedCard, IMedicalReport, IReportStatus, MedCardStatuses } from "../../../types";
import { useMedDrawerModel } from "../DrawerReportModel"
import { useAppDispatch, useAppSelector } from "../../../../../store/hooks/redux";
import { setBase64File, setDeviations, setMedCardInfo, setMedicalReport } from "../../../MedExamsSlice";
import { createDetachedSignature, getCertificate, getUserCertificates, createHash } from 'crypto-pro';
import { createSign, getUserCertificate } from "../../../../../services/cryptoService";
import { createFileFromBase64, getBase64FileRequest } from "../../../../../services/fileService";
import { setConclusion } from "../../../MedCardPageModel";
import { useModal } from "../../../../../modules/layout/components/modals/useModal";
import { ModalNames } from "../../../../../slices/AppSlice";







export const useDeclineDrawerFormModel = (onClose: any) => {

    const defaultValues: DeclineFormInputData = {
        comment: '',
        checkboxes: [],
    };

    const dispatch = useAppDispatch();
    const { card, deviations, base64FileString } = useAppSelector(state => state.examReducer)
    const { currentApiUrl } = useAppSelector(state => state.appReducer)
    const { medic } = useAppSelector(state => state.mainReducer)

    const [isDeviationsGetted, setDeviationsGetted] = useState<boolean>(false)
    const [options, setOptions] = useState<any>([])

    const templateModel = useMedDrawerModel(defaultValues);
    const { changeCurrentModal } = useModal();

    const [sMedic, setSMedic] = useState<boolean>(false)

    const [isTextFieldRequired, setTextFieldrequired] = useState<boolean>(false)
    const [disableSubmit, setDisableSubmit] = useState<boolean>(true)

    const getDeviationsToOptions = (deviations: IDeviation[] | null) => {
        const options = !!deviations ? deviations.map((element: IDeviation) => {

            if (element.id == 1 || element.id == 2) {
                return {
                    ...element,
                    declineType: 'pulse',
                }
            }
            else if (element.id == 3 || element.id == 4) {
                return {
                    ...element,
                    declineType: 'systolic pressure',
                }
            }
            else if (element.id == 5 || element.id == 6) {
                return {
                    ...element,
                    declineType: 'diastolic pressure',
                }
            }
            else {
                return element
            }

        }) : []
        console.log(options)
        return options;
    }

    useEffect(() => {
        if (card === null) onClose()
    }, [card])





    useEffect(() => {
        if (card !== null && currentApiUrl !== undefined && !isDeviationsGetted) {
            !!card.id && getDeviations(currentApiUrl, card.id);
        }
    }, [card, currentApiUrl])


    // useEffect(() => {
    //     setOptions(getDeviationsToOptions(deviations))
    // }, [deviations])

    const getDeviations = async (api_url: string, id: number) => {
        try {
            const response = await getDeviationsRequest(api_url, id);
            console.log('DEVIATIONS')

            setOptions(getDeviationsToOptions(response?.data))
            setDisableSubmit(!response?.data?.some((e: any) => e.active === true))

            console.log(response)
            dispatch(setDeviations(response.data));
            setDeviationsGetted(true)
        } catch (e) {

        }
    }


    const checkDublicatesCheckboxes = (checkboxes: any) => {
        console.log('checkDuplicatesCheckboxes')
        console.log(checkboxes)
        const checked = checkboxes;
        let dublicates = [];
        for (let i = 0; i < checked.length; i++) {
            dublicates = checked.filter((element: any) => {
                return !!checked[i].declineType &&
                    !!element.declineType && (
                        checked[i].declineType === element.declineType
                        && checked[i].id !== element.id)
            })
            console.log('dublicates')
            if (dublicates.length > 0) return true
        }

        return false
    }


    const watchCheckboxes = templateModel.watch('checkboxes')
    useEffect(()=>{
        const subscribtion = templateModel.watch((value) => {
            if(value.checkboxes.length === 0 /*&& value.comment !== ''*/) {
                setDisableSubmit(true)
                //setTextFieldrequired(true)
            }
            // else if (value.checkboxes.find((checkbox: any) => (checkbox.name === "Другое")) && value.comment === '') {
            //     setDisableSubmit(true)
            //     setTextFieldrequired(true)
            // } else if (value.checkboxes.length === 0 ) {
            //     setDisableSubmit(true)
            //     setTextFieldrequired(false)
            // }
            else {
                setDisableSubmit(false)
                // setTextFieldrequired(false)
            }
        })
        return () => subscribtion.unsubscribe()
    },[watchCheckboxes])


    const onSubmit = async (data: DeclineFormInputData) => {
        console.log('getValues')
        console.log(templateModel.getValues())
        if (data.checkboxes && data.checkboxes.length === 0 && options.some((e: any) => e.active === true)) {
          data.checkboxes = options.filter((e: any) => e.active === true)
        }
        const isDataNotEmpty = (data.checkboxes && data.checkboxes.length > 0)
        console.log(data)
        const isHasNoDuplicates = checkDublicatesCheckboxes(data.checkboxes);
        console.log(isHasNoDuplicates)
        let medicalReport:IMedicalReport | null = null;
        if (isDataNotEmpty && !isHasNoDuplicates) {
            console.log('Valid')
            // if (data.checkboxes?.find((checkbox: any) => (checkbox.id === 11))) {
            //     data.checkboxes.splice(data.checkboxes.findIndex((checkbox: any) => (checkbox.id === 11)), 1)
            //     console.log('deleted')
            // }
            if(!!medic){
                if(!!medic.id){
                    medicalReport = {  
                        deviations: data.checkboxes?.map((element: ICheckbox) => {
                            return {
                                id: element.id,
                            }
                        }),
                        comment: !!data.comment ? data.comment : undefined,
                        status: IReportStatus.REJECTED,
                        medicId:medic.id,
                        share:sMedic
                    }
                    dispatch(setMedicalReport(medicalReport))
                    changeCurrentModal(ModalNames.CERTIFICATES)
                 
                    onClose();
                }
            }

            // changeCurrentModal(ModalNames.ECP_SIGNING)
            // try {

            //     if (!!medic) {
            //         if (medic.id !== null && !!medicalReport) {
            //             const conclusionResult = await setConclusion(card, medicalReport, medic.id)
            //             console.log('CONCLUSION')
            //             console.log(conclusionResult)

            //             if (!!conclusionResult) {
                            
            //                 changeCurrentModal(ModalNames.SUCCESS)
            //             } else {
            //                 changeCurrentModal(ModalNames.ECP_ERROR)
            //             }
            //             dispatch(setMedCardInfo(null))
            //             dispatch(setBase64File(undefined))
            //             onClose();
            //         }

            //     }

            // } catch (e) {
            //     return
            // }


        } else console.log('Not Valid')
    };

    const submitHandler = templateModel.handleSubmit(onSubmit)

    return {
        control: templateModel.control,
        onSubmit,
        submitHandler,
        handleFormValues: templateModel.setValue,
        register: templateModel.register,
        getValues: templateModel.getValues,
        setValue: templateModel.setValue,
        options,
        sMedic, setSMedic,

        isTextFieldRequired,
        disableSubmit,
    }
}